function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.67,
  cy: 13,
  r: 1.001
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.09,15.391C13.482,15.826,12.746,16.041,12,16c-0.744,0.034-1.479-0.189-2.081-0.63c-0.099-0.081-0.242-0.081-0.342,0 c-0.115,0.095-0.132,0.265-0.037,0.38c0.71,0.535,1.582,0.809,2.471,0.77c0.887,0.039,1.76-0.233,2.469-0.77v0.04 c0.109-0.106,0.111-0.285,0.006-0.396C14.377,15.284,14.2,15.282,14.09,15.391z M14.299,12.04c-0.552,0-0.999,0.448-0.999,1.001 c0,0.552,0.447,0.999,0.999,0.999l-0.008,0.039c0.016,0.002,0.033,0,0.051,0c0.551-0.021,0.979-0.487,0.958-1.038 C15.3,12.488,14.854,12.04,14.299,12.04z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12,2C6.479,2,2,6.477,2,12c0,5.521,4.479,10,10,10c5.521,0,10-4.479,10-10C22,6.477,17.521,2,12,2z M17.859,13.33 c0.012,0.146,0.012,0.293,0,0.439c0,2.24-2.609,4.062-5.83,4.062c-3.221,0-5.83-1.82-5.83-4.062c-0.012-0.146-0.012-0.293,0-0.439 c-0.145-0.066-0.275-0.155-0.392-0.264c-0.587-0.553-0.614-1.478-0.063-2.063c0.552-0.588,1.477-0.616,2.063-0.063 c1.152-0.781,2.509-1.209,3.899-1.23l0.743-3.47c0-0.001,0-0.002,0-0.004C12.487,6.069,12.652,5.964,12.82,6l2.449,0.49 c0.16-0.275,0.44-0.458,0.758-0.492c0.55-0.059,1.041,0.338,1.102,0.888c0.059,0.549-0.338,1.042-0.889,1.101 c-0.549,0.059-1.041-0.338-1.102-0.887L13,6.65l-0.649,3.12c1.375,0.029,2.711,0.457,3.85,1.23c0.259-0.248,0.599-0.393,0.957-0.406 c0.807-0.029,1.482,0.6,1.512,1.406C18.68,12.563,18.363,13.08,17.859,13.33z"
});

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.454ce3e0.svg";
export { ForwardRef as ReactComponent };